function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2148",
  "data-name": "Group 2148",
  transform: "translate(-209 -5.264)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1722",
  "data-name": "Group 1722",
  transform: "translate(-116.356 -316.896)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_531",
  "data-name": "Grupo 531",
  transform: "translate(339.892 322.16)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_528",
  "data-name": "Grupo 528"
}, /*#__PURE__*/React.createElement("g", {
  id: "Caminho_853",
  "data-name": "Caminho 853"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1119",
  "data-name": "Path 1119",
  d: "M344.242,329.156a3.373,3.373,0,1,1,3.374-3.373h0A3.377,3.377,0,0,1,344.242,329.156Zm0-6.4a3.024,3.024,0,1,0,3.024,3.024A3.025,3.025,0,0,0,344.242,322.759Z",
  transform: "translate(-340.63 -322.172)",
  fill: "#757575"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1120",
  "data-name": "Path 1120",
  d: "M344.23,329.383h0a3.612,3.612,0,1,1,3.612-3.612A3.616,3.616,0,0,1,344.23,329.383Zm0-6.4a2.785,2.785,0,1,0,2.786,2.786,2.789,2.789,0,0,0-2.786-2.786Z",
  transform: "translate(-340.618 -322.16)",
  fill: "#757575"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1007",
  "data-name": "Group 1007",
  transform: "translate(3.196 1.496)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1121",
  "data-name": "Path 1121",
  d: "M345.93,327.226l-1.355-1.355v-1.89h-.35l.012,2.047,1.445,1.445Z",
  transform: "translate(-343.986 -323.743)",
  fill: "#757575"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1122",
  "data-name": "Path 1122",
  d: "M345.671,327.8l-1.683-1.683-.015-2.384h.828v2.03l1.454,1.454Z",
  transform: "translate(-343.974 -323.731)",
  fill: "#757575"
}))), /*#__PURE__*/React.createElement("g", {
  id: "graph",
  transform: "translate(-209.644 -115.604)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_924",
  "data-name": "Path 924",
  d: "M0,0H4V16H0Z",
  transform: "translate(540 438.5)",
  fill: "#757575"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_925",
  "data-name": "Path 925",
  d: "M0,0H4V8H0Z",
  transform: "translate(545 446.5)",
  fill: "#757575"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_926",
  "data-name": "Path 926",
  d: "M0,0H4V6H0Z",
  transform: "translate(550 448.5)",
  fill: "#757575"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_992",
  "data-name": "Path 992",
  d: "M0,0H4V9.021H0Z",
  transform: "translate(535 445.479)",
  fill: "#757575"
}))));

function SvgGraphLive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.759,
    height: 16.736,
    viewBox: "0 0 21.759 16.736",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphLive);
export default __webpack_public_path__ + "static/media/graph-live.75ff2caf.svg";
export { ForwardRef as ReactComponent };